export default "/images/8a3dfb9f885fd85758f4d9ea36d29f57.avif";